<div class="image-viewer">

    <button class="close-btn" (click)="close()">
        ✕
    </button>

    <img
        [src]="data.image"
        [alt]="data.name"
        class="preview-image"
    />

    <div class="image-name">
        {{ data.name }}
    </div>

</div>